import api from './api';

export const getAllMentors = async () => {
  const response = await api.get('/mentors/');
  return response.data;
};

export const getMentorById = async (mentorId) => {
  const response = await api.get(`/mentors/${mentorId}`);
  return response.data;
};

export const getMyProfile = async () => {
  const response = await api.get('/mentors/me');
  return response.data;
};

export const createMentor = async (mentorData) => {
  const response = await api.post('/mentors/', mentorData);
  return response.data;
};

export const createSelfAccount = async (mentorData) => {
  const response = await api.post('/mentors/create_self', mentorData);
  return response.data;
};

export const updateMentor = async (mentorId, mentorData) => {
  const response = await api.put(`/mentors/${mentorId}`, mentorData);
  return response.data;
};

export const updateMentorRate = async (mentorId, perHourRate) => {
  const response = await api.patch(`/mentors/${mentorId}/rate`, { per_hour_rate: perHourRate });
  return response.data;
};

export const updateMentorInvoiceFlag = async (mentorId, invoiceGenerate) => {
  const response = await api.patch(`/mentors/${mentorId}/invoice-flag`, { invoice_generate: invoiceGenerate });
  return response.data;
};

export const deleteMentor = async (mentorId) => {
  const response = await api.delete(`/mentors/${mentorId}`);
  return response.data;
};

export const suspendMentor = async (userId, reason = null) => {
  const response = await api.post(`/auth/suspend-user/${userId}`, null, {
    params: { reason }
  });
  return response.data;
};

export const unsuspendMentor = async (userId) => {
  const response = await api.post(`/auth/unsuspend-user/${userId}`);
  return response.data;
};